<template>
  <modal
    class="editPumpStat pb-3"
    name="walletPay"
    transition="pop-out"
    :width="modalWidth"
    :height="500"
    @opened="opened"
  >
    <div class="modal__header">
      <h5 class="text-center text-white p-3">
        {{ $t("text.invoicesModal.walletPay") }}
      </h5>
    </div>
    <div class="modal-form-wrapper mt-3">
      <div class="pb-3 text-center">
        <img src="@/assets/img/money (3).svg" width="50" />
        <div class="text-center mt-4">
          {{ $t("text.invoicesModal.enoughFundsInCompany") }}
        </div>
      </div>
    </div>
    <!-- <div class="mx-auto text-center" style="width: 500px"> -->
    <div class="mx-auto text-center">
      <ul class="mt-3 p-4">
        <li
          class="list-group-item d-flex justify-content-between align-items-center"
        >
          {{ $t("text.invoicesModal.walletBal") }}
          <span class="text-secondary"
            ><span class="bold-span">{{
              comCountry == "Nigeria" ? "₦" : "$"
            }}</span
            >{{ convertThousand(idet.walletBalance) }}</span
          >
        </li>
        <li
          class="list-group-item d-flex justify-content-between align-items-center"
        >
          {{ $t("text.invoicesModal.amountDue") }}
          <span class="text-secondary">
            <span class="bold-span">{{
              comCountry == "Nigeria" ? "₦" : "$"
            }}</span
            >{{ convertThousand(idet.amountDue) }}</span
          >
        </li>
      </ul>
    </div>
    <hr class="invoice_mod_hr mt-3" />
    <div class="text-right mr-3">
      <button class="invoice_btn" @click="hideModal">
        {{ $t("text.actionButtons.cancel") }}
      </button>
      <button
        :style="[
          isButtonDisabled ? { cursor: 'not-allowed' } : { cursor: 'pointer' },
        ]"
        class="invoice_btn colored"
        @click="payWallet()"
      >
        {{ $t("text.invoicesModal.pay") }}
        <img
          src="@/assets/img/git_loader.gif"
          style="display: none"
          width="22px"
          class="ml-3 loader"
        />
      </button>
    </div>
  </modal>
</template>
<script>
const MODAL_WIDTH = 700;
import configObject from "@/config";
import Jquery from "jquery";
let $ = Jquery;

export default {
  name: "walletPay",
  props: ["id", "idet", "company"],
  data() {
    return {
      isButtonDisabled: false,
      modalWidth: MODAL_WIDTH,
      comCountry: null,
    };
  },
  watch: {},
  mounted() {},
  created() {
    this.modalWidth =
      window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;
  },
  methods: {
    hideModal() {
      this.$modal.hide("walletPay");
    },
    opened() {
      this.comCountry = this.company.country;
    },
    convertThousand(request) {
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    payWallet() {
      $(".loader").show();
      this.isButtonDisabled = true;
      const data = {
        invoiceId: this.id,
        amountPaid: this.idet.amountDue,
      };
      this.axios
        .post(
          `${configObject.apiBaseUrl}/Invoices/settle-invoice-payment`,
          data,
          configObject.authConfig()
        )
        .then((response) => {
          this.$toast.open({
            message: this.$t("text.invoicesModal.paymentSuccessful"),
            type: "success",
            duration: 3000,
          });
          this.isButtonDisabled = false;
          $(".loader").hide();
          this.$modal.hide("walletPay");
          if (this.$route.name == "industrial_admin_invoice_details") {
            this.routeToInd();
          } else {
            this.routeToCom();
          }
        })
        .catch((error) => {
          $(".loader").hide();
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 3000,
          });
        });
    },
    routeToInd() {
      this.$router.push({
        name: "industrial_admin_invoice",
        query: { companyId: this.idet.customerId },
      });
    },
    routeToCom() {
      this.$router.push({
        name: "company_invoice",
        query: { companyId: this.idet.customerId },
      });
    },
  },
};
</script>
